import React from "react";
import Carousel from "react-bootstrap/Carousel";
import CloseIcon from "@mui/icons-material/Close";
import {Color} from "../Color";
import LockCompetitor from "../../Button/LockCompetitor";
import {Change} from "../Change";

const LandscapeCompetitorView = ({
                                     setPrimaryAndSecondaryVehicles,
                                     setSecondaryVehicles,
                                     isLocked,
                                     checkLockStatus,
                                     removeVehicle,
                                     getCompetitorImages,
                                     activeLocale,
                                     t,
                                     currencyConverter,
                                     changeHandler,
                                     trimCodes,
                                     handleToggle,
                                     vehicleData,
                                     setVehicleData,
                                     openModal,
                                     setOpenModal,
                                     handleChangeModalClose,
                                     secondaryYear,
                                     vehiclesMakes,
                                     vehicleModel,
                                     trimModel,
                                     setTrimModel,
                                     setVehicleModel,
                                     setVehicleMake,
                                     vehiclesTrim,
                                     vehicleIndex,
                                     vehicleTypeName,
                                     driveType,
                                     setDriveType,
                                     dispatch,
                                     getCarouselIndexKey,
                                     buildTablet,
                                     buildMissingCarousel
                                 }) => {
    return (
        <React.Fragment>
            <div className={"competitor-vehicle"}>
                {
                    setPrimaryAndSecondaryVehicles[1] ?
                        <div className="competitor-vehicle-overview">
                            <button
                                type="button"
                                className={"close-compare"}
                                id={"features-vehicle-remove"}
                                onClick={() => removeVehicle(setPrimaryAndSecondaryVehicles[1], 1)}
                                disabled={isLocked && checkLockStatus(setPrimaryAndSecondaryVehicles[1], isLocked,1)}
                            >
                                <CloseIcon fontSize={"medium"}/>
                            </button>
                            {setPrimaryAndSecondaryVehicles[1] &&
                                getCompetitorImages(setPrimaryAndSecondaryVehicles[1], activeLocale)}

                            <div className={"vehicle-detail"}>
                                <div className={"competitor-vehicle-yearMake"}>
                                    {setPrimaryAndSecondaryVehicles[1]?.year} {setPrimaryAndSecondaryVehicles[1]?.make}
                                </div>
                                <div className={"competitor-vehicle-yearMake"}>
                                    {setPrimaryAndSecondaryVehicles[1]?.model} {setPrimaryAndSecondaryVehicles[1]?.trim}
                                </div>
                                <div className={"price-start"}>
                                    {setPrimaryAndSecondaryVehicles[1] &&
                                        <span>{t('overview.startingFrom')} </span>}

                                    {setPrimaryAndSecondaryVehicles[1] &&
                                        <span> {currencyConverter(setPrimaryAndSecondaryVehicles[1]?.pricing.msrp, activeLocale)}*</span>}
                                </div>
                            </div>
                        </div> :
                        <div className="competitor-vehicle-overview">
                            <div className="no-vehicle">{t('overview.noVehicleSelected')}</div>
                        </div>
                }
                <div className={"secondary-feature-controller"}>
                    <div className={"color-box-controller"}
                         style={{
                             left: ['en-CA', 'en-US'].includes(activeLocale) ? '-10px' : '-9px',
                         }}
                    >
                        <Color
                            primaryColor={
                                setPrimaryAndSecondaryVehicles[1]?.colors?.exteriors
                            }
                            translate={t}
                            mediaColor = { setPrimaryAndSecondaryVehicles[1]?.currentColor}
                            interiorColor={setPrimaryAndSecondaryVehicles[1]?.colors?.interiors}
                        />
                    </div>
                    <div className={"secondaryvehicleController"}>
                        <button
                            id={1}
                            className={isLocked && checkLockStatus(setPrimaryAndSecondaryVehicles[1], isLocked,1) ? "btn-default btn-change-disabled" :"btn-default btn-change-compare"}
                            value={setPrimaryAndSecondaryVehicles[1]}
                            onClick={(event) => changeHandler(1, setPrimaryAndSecondaryVehicles[1])}
                            disabled={isLocked && isLocked[1]}
                            title={checkLockStatus(setPrimaryAndSecondaryVehicles[1], isLocked,1)? t("overview.changeSelectModal.vehicleLocked") : null}
                        >
                            {setPrimaryAndSecondaryVehicles[1]  ?
                                t('overview.changeSelectModal.change') :  t('overview.controls.selectVehicle')}
                        </button>

                        <LockCompetitor isLocked={isLocked}
                                        vehicle={setPrimaryAndSecondaryVehicles[1]}
                                        vehicleIndex = {1}
                                        trimCodes={trimCodes}
                                        toggleLock={() =>handleToggle(1,setPrimaryAndSecondaryVehicles[1])} />

                        <Change vehicleData={vehicleData}
                                setVehicleData={setVehicleData}
                                openModal={openModal}
                                setOpenModal={setOpenModal}
                                handleModalClose={handleChangeModalClose}
                                years={secondaryYear}
                                vehicleMake={vehiclesMakes}
                                vehicleModels={vehicleModel}
                                trimModel={trimModel}
                                setTrimModel={setTrimModel}
                                setVehicleModel={setVehicleModel}
                                setVehicleMake={setVehicleMake}
                                vehiclesTrim={vehiclesTrim}
                                vehicleIndex={vehicleIndex}
                                vehicleTypeName = {vehicleTypeName}
                                driveType={driveType}
                                setDriveType={setDriveType}
                                lockedVehicle={isLocked}
                        />
                    </div>
                </div>
            </div>
            <div className={"competitor-vehicle"}>
                <Carousel
                    indicators={false}
                    interval={null}
                    controls={false}
                    defaultActiveIndex={0}
                    onSelect={(eventKey, event) => dispatch(getCarouselIndexKey(eventKey))}
                >
                    {setSecondaryVehicles.map((vehicle, index) => {
                        return buildTablet(vehicle, index, true);
                    })}
                    {setSecondaryVehicles.length === 2 &&
                        <Carousel.Item id={2}>
                            <div className="competitor-vehicle-overview">
                                <div className="no-vehicle"> {t('overview.noVehicleSelected')}</div>
                            </div>
                            <div className={"change-modal"}>
                                <button
                                    id={setSecondaryVehicles.length}
                                    className={isLocked && checkLockStatus(setPrimaryAndSecondaryVehicles[setSecondaryVehicles.length], isLocked,setSecondaryVehicles.length) ? "btn-default btn-change-disabled" :"btn-default btn-change-compare"}
                                    value={""}
                                    onClick={(event) => changeHandler(setSecondaryVehicles.length, "")}
                                    title={checkLockStatus(setPrimaryAndSecondaryVehicles[setSecondaryVehicles.length], isLocked,setSecondaryVehicles.length)? t("overview.changeSelectModal.vehicleLocked") : null}
                                >
                                    {t('overview.controls.selectVehicle')}
                                </button>

                                <LockCompetitor isLocked={isLocked}
                                                vehicle={setPrimaryAndSecondaryVehicles[setSecondaryVehicles.length]}
                                                vehicleIndex = {2}
                                                trimCodes={trimCodes}
                                                toggleLock={() =>handleToggle(setSecondaryVehicles.length,setPrimaryAndSecondaryVehicles[setSecondaryVehicles.length])} />
                                <Change
                                    vehicleData={vehicleData}
                                    setVehicleData={setVehicleData}
                                    openModal={openModal}
                                    setOpenModal={setOpenModal}
                                    handleModalClose={handleChangeModalClose}
                                    years={secondaryYear}
                                    vehicleMake={vehiclesMakes}
                                    vehicleModels={vehicleModel}
                                    trimModel={trimModel}
                                    setTrimModel={setTrimModel}
                                    setVehicleModel={setVehicleModel}
                                    setVehicleMake={setVehicleMake}
                                    vehiclesTrim={vehiclesTrim}
                                    vehicleIndex={vehicleIndex}
                                    vehicleTypeName={vehicleTypeName}
                                    driveType={driveType}
                                    setDriveType={setDriveType}
                                    lockedVehicle={isLocked}
                                />
                            </div>
                        </Carousel.Item>
                    }
                    { setSecondaryVehicles.length <=3  &&
                        buildMissingCarousel(setSecondaryVehicles.length, "")
                    }
                </Carousel>
            </div>
        </React.Fragment>
    );
};

export default LandscapeCompetitorView;
